import { get, post, put, deleteR } from '@/services/API';

export default {
  postResearchSheet: (researchSheet) => post('/api/researchSheet', researchSheet),
  getAllResearchSheets: (params) => get(`/api/researchSheet?${new URLSearchParams(params)}`),
  getResearchSheet: (id) => get(`/api/researchSheet/${id}`),
  putResearchSheet: (researchSheet) => put(`/api/researchSheet/${researchSheet._id}`, researchSheet),
  deleteResearchSheet: (id) => deleteR(`/api/researchSheet/${id}`),
};
